<template>
  <v-row>
    <v-col cols="12">
      <gg-card>
        <gg-card-header>
          <v-row>
            <v-col cols="12" md="6" class="d-md-flex justify-space-between">
              <div>
                Domains
              </div>
              <v-slide-x-transition>
                <div v-if="selectedDomain">
                  <gg-btn class="my-1 my-md-0 mx-1" secondary @click="selectedDomain = null">Go Back</gg-btn>
                  <gg-btn class="my-1 my-md-0 mx-1" @click="detailsAction('reload')">Refresh List</gg-btn>
                  <gg-btn class="my-1 my-md-0 mx-1" @click="detailsAction('reset')">Reset Zone</gg-btn>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <gg-btn class="my-md-0 mx-1" v-on="on">
                        Add Record
                      </gg-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="detailsAction('addA')">
                        <v-list-item-title>Add A Record</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="detailsAction('addAAA')">
                        <v-list-item-title>Add AAA Record</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="detailsAction('addCAA')">
                        <v-list-item-title>Add CAA Record</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="detailsAction('addCNAME')">
                        <v-list-item-title>Add CNAME Record</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="detailsAction('addDMARK')">
                        <v-list-item-title>Add DMARC Record</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="detailsAction('addMX')">
                        <v-list-item-title>Add MX Record</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="detailsAction('addSRV')">
                        <v-list-item-title>Add SRV Record</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="detailsAction('addTXT')">
                        <v-list-item-title>Add TXT Record</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </v-slide-x-transition>
            </v-col>
            <v-col cols="12" md="6" class="font-weight-regular">
              <gg-text-field
                v-model="domainSearch"
                hide-details
                placeholder="Search"
                append-icon="mdi-magnify"
              />
            </v-col>
          </v-row>
        </gg-card-header>
        <gg-card-text>
          <domains-table
            v-if="!selectedDomain"
            :is-reseller-owner="isResellerOwner"
            :is-reseller-route="isResellerRoute"
            :search="domainSearch"
            :table-should-be-reloaded="false"
            @show-details="showDetails($event)"
          />
          <details-table
            v-else
            ref="detailsTable"
            :table-should-be-reloaded="false"
            :search="domainSearch"
            :domain="selectedDomain"
            :username="selectedUsername"
            @domain-error="hideDetails"
            @back="hideDetails"
          />
        </gg-card-text>
      </gg-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import { ZONE_TYPES } from '@/consts/zone-edit'
import { SERVICE_TYPES } from '@/consts/service'
import DomainsTable from '@/components/Services/Hosting/Shared/Domains/ZoneEditor/DomainsTable'
import DetailsTable from '@/components/Services/Hosting/Shared/Domains/ZoneEditor/DetailsTable'

export default {
  name: 'ZoneEditorView',
  components: {
    DomainsTable,
    DetailsTable,
  },
  data () {
    return {
      selectedDomain: null,
      selectedUsername: '',
      domainSearch: ''
    }
  },
  computed: {
    ...mapGetters(['hosting', 'hosting_detail', 'resellerSubAccounts']),
    isReseller () {
      return this.hosting.type === SERVICE_TYPES.RESELLER
    },
    isResellerOwner () {
      if (!this.$route.query.user) {
        // if no user is specified, we are the owner? (/hosting/reseller/ routes)
        return this.isReseller
      }
      return this.$route.query.user == this.hosting.username
    },
    isResellerRoute () {
      return this.$route.meta.parent === 'hosting_reseller'
    },
  },
  methods: {
    showDetails ({ domain, username }) {
      this.selectedDomain = domain
      this.selectedUsername = username
    },
    detailsAction (action) {
      const detailsTable = this.$refs.detailsTable
      if (!detailsTable) return

      const regularActions = {
        reload: () => detailsTable.debounceReload(),
        reset: () => detailsTable.resetZone()
      }

      if (regularActions[action]) {
        return regularActions[action]()
      }

      if (ZONE_TYPES[action]) {
        return detailsTable.openModal('addRecord', { domain: this.selectedDomain, type: ZONE_TYPES[action] })
      }
    },
    hideDetails () {
      this.selectedDomain = null
      this.selectedUsername = ''
    }
  }
}
</script>
